export enum MetricIds {
  Aht = 1,
  Csat = 2,
  CsatPercentage = 3,
  EstimatedCsat = 4,
  EstimatedCsatPercentage = 5,
  Nps = 6,
  NegativeSentiment = 7,
  Nonfcr = 8,
  AiResolvedConversation = 9,
  TransferRate = 10,
  HandoverRate = 11,
  ResolutionType = 12,
}